import { LayoutWidthBreakpoints } from '../interfaces';

/**
 * Horizontal margin applied to each accordion panel when the question-flow timeline is visible.
 * This value is also used in question-flow.component.scss (.block-accordion { margin-left }).
 * Keep both in sync when changing.
 */
export const ACCORDION_TIMELINE_MARGIN_PX = 48;

/**
 * Default breakpoints used by the ResizeObserver directive when no custom breakpoints are provided.
 * These values are relative to the full width of the observed element (e.g. the browser viewport
 * or a full-width container).
 */
export const DEFAULT_LAYOUT_WIDTH_BREAKPOINTS: LayoutWidthBreakpoints = {
    xSmallMax: 640,
    smallMax: 768,
    mediumMax: 1024,
    largeMax: 1280
};

/**
 * Breakpoints relative to the width of a single question-flow accordion panel.
 */
export const ACCORDION_LAYOUT_WIDTH_BREAKPOINTS: LayoutWidthBreakpoints = {
    xSmallMax: 590,
    smallMax: 590,
    mediumMax: 811,
    largeMax: 1280
};
